import { css, html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'
import { TextBlockElementModel, TextSettingsElementModel } from '../api/ContentDeliveryApi.schemas'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'
import { RenderButton } from '../Shared/Button'
import { RichTextStyles } from '../Shared/RichText'

@customElement('lindberg-text-block')
export class TextBlock extends LitElement {
    static styles = [RichTextStyles, css`
        :host { 
            display: grid;
            align-self: var(--vertical-align);
            grid-auto-flow: row;
            color: light-dark(var(--color-text-base-dark), var(--color-text-base-light));
        }
        
        :host(.box-margin) {
            padding: var(--elements-box-margins);
        }
        :host(.center){
            text-align: center;
        }
        :host(.left){   
            text-align: left;
        }
        :host(.right){
            text-align: right;
        }
        :host(.middle){
            align-self: center;
        }
        :host(.top){
            align-self: start;
        }
        :host(.bottom){
            align-self: end;
        }
        *:has(+ lindberg-button) {
            margin-bottom: var(--elements-box-spacing);
        }
    `]

	private _data: { content: TextBlockElementModel; settings: TextSettingsElementModel} 
    public get data(): { content: TextBlockElementModel; settings: TextSettingsElementModel}  {
        return this._data
    }
    public set data(value: { content: TextBlockElementModel; settings: TextSettingsElementModel} ) {
        this.classList.toggle('box-margin', value.settings?.properties?.boxMargin === true)

        this._data = value
    }

	override connectedCallback(): void {
		super.connectedCallback()
		// if (!this.data.settings) return
		// if (this.data.settings.contentType == 'gridSettings' && this.data.settings?.properties?.textPosition) {
		// console.log('gridSettings', this.data.content.properties.label, this.data.settings?.properties)
		if (this.data.settings?.properties.contentAlign) {
			const [vertical, horizontal] = this.data.settings?.properties.contentAlign.split(' ')
            this.data.settings?.properties.contentAlign?.split(' ').forEach(x => this.classList.add(x))
		}
		// this.style.setProperty('--vertical-align', vertical.replace('middle', 'center').replace('top', 'start').replace('bottom', 'end'))
		// console.log('gridSettings', this.data.settings.properties.textPosition)
		// if(this.data.settings?.properties) this.style.setProperty('--text-align', (this.data.settings.properties as any).textAlign) // TODO: dont
		// if () this.style.setProperty('--text-align', this.data.settings.properties.textPosition)
        if(this.data.settings?.properties?.backgroundColor?.value) this.style.setProperty('background', this.data.settings.properties.backgroundColor.value)
		if (this.data.settings?.properties?.maxTextLength) this.style.setProperty('--max-text-length', this.data.settings.properties.maxTextLength + 'ch')
	}

	render() {
		return html`
            ${unsafeHTML(this.data.content.properties?.text?.markup || '')}
            ${this.data.content.properties.link ? RenderButton(this.data.content.properties.link) : ''}
        `
	}
}
